// https://vuex.vuejs.org/en/state.html

export default {
  messages: {
    success: '',
    error: {},
    warning: '',
    validation: {},
  },
  help_icon_route: [],
  fetching: false,
  permissions:()=>JSON.parse(localStorage.getItem('permissions')),
}



// WEBPACK FOOTER //
// ./src/store/state.js